var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import moment from 'moment';
import { toYuan } from '../../../utils/unit-conversion';
import table from '../../../components/fund/table.vue';
import btnExport from '../../../components/console-common/export-btn.vue';
export default Vue.extend({
    name: 'deductDetail',
    components: {
        'el-fund-table': table,
        'el-export-btn': btnExport,
    },
    data: function () {
        return {
            isEmpty: false,
            isDefaultRequest: false,
            dateRange: [],
            date: '',
            contractCodeOrTenantName: '',
            startDate: '',
            endDate: '',
            tableDataConfig: [
                {
                    label: '商户名称',
                    prop: 'tenantName',
                    minWidth: '200px',
                },
                {
                    label: '合同号',
                    prop: 'contractCode',
                    minWidth: '200px',
                },
                {
                    label: '还款方式',
                    prop: 'repayMethod',
                    minWidth: '110px',
                    filters: [
                        {
                            text: '余额代扣',
                            value: 'BALANCE',
                        },
                        {
                            text: '线下还款',
                            value: 'OFFLINE',
                        },
                    ],
                    filterMultiple: false,
                    formatter: function (current) {
                        var deductMode = {
                            BALANCE: '余额代扣',
                            OFFLINE: '线下还款',
                        };
                        return current ? deductMode[current] : '--';
                    },
                },
                {
                    label: '还款时间',
                    prop: 'rentTime',
                    minWidth: '180px',
                    formatter: function (current) {
                        return current ? moment(current).format('YYYY-MM-DD') : '--';
                    },
                },
                {
                    label: '还款金额（元）',
                    prop: 'amount',
                    align: 'right',
                    minWidth: '140px',
                    formatter: function (current) {
                        return current === 0 || current ? toYuan(current).toFixed(2) : '--';
                    },
                },
                {
                    label: '还款状态',
                    prop: 'status',
                    minWidth: '110px',
                    // filters: [
                    //   {
                    //     text: '成功',
                    //     value: 'SUCCESS',
                    //   },
                    //   {
                    //     text: '处理中',
                    //     value: 'PRE',
                    //   },
                    //   {
                    //     text: '失败',
                    //     value: 'FAIL',
                    //   },
                    // ],
                    // filterMultiple: false,
                    formatter: function (current) {
                        var status = {
                            SUCCESS: '成功',
                            FAIL: '失败',
                            PRE: '处理中',
                        };
                        return current ? status[current] : '--';
                    },
                },
                {
                    label: '所属期数',
                    prop: 'durationNo',
                    minWidth: '100px',
                },
                {
                    label: '本期还款周期',
                    prop: 'time',
                    minWidth: '220px',
                    formatter: function (current, row) {
                        var planStartTime = row.planStartTime, planEndTime = row.planEndTime;
                        return (planStartTime ? moment(planStartTime).format('YYYY-MM-DD') : '--') + "\u81F3" + (planEndTime ? moment(planEndTime).format('YYYY-MM-DD') : '--');
                    },
                },
                {
                    label: '本期总金额（元）',
                    prop: 'planAmount',
                    align: 'right',
                    minWidth: '160px',
                    formatter: function (current) {
                        return current ? toYuan(current).toFixed(2) : '--';
                    },
                },
                {
                    label: '本期已还金额（元）',
                    prop: 'planPaidAmount',
                    align: 'right',
                    minWidth: '200px',
                    formatter: function (current) {
                        return current ? toYuan(current).toFixed(2) : '--';
                    },
                },
                {
                    label: '本期待还金额（元）',
                    prop: 'remains',
                    align: 'right',
                    minWidth: '200px',
                    formatter: function (current) {
                        return current ? toYuan(current).toFixed(2) : '--';
                    },
                },
                {
                    label: '本合同还款计划总金额（元）',
                    prop: 'totalPlanAmount',
                    align: 'right',
                    minWidth: '240px',
                    formatter: function (current) {
                        return current ? toYuan(current).toFixed(2) : '--';
                    },
                },
                {
                    label: '本合同已还金额（元）',
                    prop: 'totalPaidAmount',
                    align: 'right',
                    minWidth: '200px',
                    formatter: function (current) {
                        return current ? toYuan(current).toFixed(2) : '--';
                    },
                },
                {
                    label: '本合同待还款金额（元）',
                    prop: 'totalRemainAmount',
                    align: 'right',
                    minWidth: '200px',
                    formatter: function (current) {
                        return current ? toYuan(current).toFixed(2) : '--';
                    },
                },
            ],
            tableRequestConfig: {
                url: '/proxy/fund-api/capital/repay/record/list/employer',
                method: 'post',
                inputParam: {
                    startTime: '',
                    endTime: '',
                    contractCodeOrTenantName: '',
                    repayMethod: '',
                    status: '',
                },
            },
            cellConfig: {
                status: [
                    {
                        status: 'FAIL',
                        style: 'color:#FF5257',
                    },
                ],
            },
        };
    },
    computed: {
        exportParams: function () {
            return this.tableRequestConfig.inputParam;
        },
    },
    created: function () {
        this.init();
    },
    methods: {
        // spanMethod ({ rowIndex, columnIndex }) {
        //   console.log(rowIndex)
        //   if (rowIndex === 0) {
        //     if (columnIndex === 0) {
        //       return {
        //         rowspan: 1,
        //         colspan: this.tableDataConfig.length
        //       }
        //     } else {
        //       return {
        //         rowspan: 0,
        //         colspan: 0
        //       }
        //     }
        //   }
        // },
        init: function () {
            var _a = this.$route.query, tenantName = _a.tenantName, startTime = _a.startTime, endTime = _a.endTime;
            this.dateRange = [startTime, endTime];
            this.contractCodeOrTenantName = tenantName;
            this.defaultSearch();
            this.isDefaultRequest = true;
        },
        defaultSearch: function () {
            var startTime = this.dateRange[0];
            var endTime = this.dateRange[1];
            this.tableRequestConfig.inputParam = Object.assign(this.tableRequestConfig.inputParam, {
                startTime: startTime,
                endTime: endTime,
                contractCodeOrTenantName: this.contractCodeOrTenantName,
            });
        },
        tabDate: function (val) {
            this.dateRange = [];
            var startTime = '';
            var endTime = '';
            var currentDate = new Date();
            var getDateRange = function (date) {
                startTime = moment(new Date(date.getFullYear(), date.getMonth(), 1)).format('YYYY-MM-DD');
                endTime = moment(date).format('YYYY-MM-DD');
            };
            if (val === 'current') {
                var currentMonth = new Date(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1).getTime() -
                    1 * 24 * 60 * 60 * 1000);
                getDateRange(currentMonth);
            }
            if (val === 'last') {
                var lastMonth = new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getTime() -
                    1 * 24 * 60 * 60 * 1000);
                getDateRange(lastMonth);
            }
            this.tableRequestConfig.inputParam.startTime = startTime;
            this.tableRequestConfig.inputParam.endTime = endTime;
        },
        tabDateRange: function (val) {
            this.date = '';
            var startTime = '';
            var endTime = '';
            startTime = val ? moment(val[0]).format('YYYY-MM-DD') : '';
            endTime = val ? moment(val[1]).format('YYYY-MM-DD') : '';
            this.tableRequestConfig.inputParam.startTime = startTime;
            this.tableRequestConfig.inputParam.endTime = endTime;
        },
        search: function () {
            this.tableRequestConfig.inputParam.contractCodeOrTenantName = this.contractCodeOrTenantName;
        },
        filterChange: function (filters) {
            var filtersObj = {};
            for (var key in filters) {
                filtersObj[key] = filters[key].length > 0 ? filters[key][0] : '';
            }
            this.tableRequestConfig.inputParam = Object.assign(this.tableRequestConfig.inputParam, __assign({}, filtersObj));
        },
        getRequestResult: function (_a) {
            var isHaveData = _a.isHaveData;
            this.isEmpty = isHaveData;
        },
    },
});
